import Vue from 'vue'
import {namespace} from 'vuex-class'
import {AM_CHAR_PBS, AM_MODULE_NAMESPACE} from '../../../store/agency-management'
import {Component, Watch} from 'vue-property-decorator'
const AMStore = namespace(AM_MODULE_NAMESPACE)

@Component({
  components: {}
})
class CharProblem extends Vue {
  /* eslint-disable no-undef */
  @AMStore.Action(AM_CHAR_PBS)
  storeGetCharPb: (payload: any) => Promise<any>

  @AMStore.Getter characterProblems: any;

  charPbDisabled: boolean
  _clearTimeout: any

  constructor (prop) {
    super(prop)
    this.charPbDisabled = false
  }

  created () {
    this.storeGetCharPb(this.searchParam)
      .then(res => {
        // console.log('characterProblems', this.characterProblems)
      })
  }

  mounted () {
    // console.log('Meta char pb ', this.$route.meta)
  }

  @Watch('charPbDisabled')
  handleFiltersChange (value) {
    clearTimeout(this._clearTimeout)
    this._clearTimeout = setTimeout(() => {
      this.storeGetCharPb(this.searchParam)
    }, 500)
  }

  get lblSetting () {
    return {
      ...require('@/locales/profile').default,
      ...require('@/locales/agency-management').default
    }
  }

  get charPbLvl1 () {
    if (!this.characterProblems) return []
    return this.characterProblems.level_1
  }

  get searchParam () {
    return {
      enabled: !this.charPbDisabled
    }
  }
}

export default CharProblem



// WEBPACK FOOTER //
// ./src/containers/profile/char-problem/index.ts